export const REQUEST_CALCULATED_ORDER_SUCCESS = 'REQUEST_CALCULATED_ORDER_SUCCESS';